/**
 * RouteError — errorElement dùng cho mọi route. Bắt lỗi loader/render, hiển thị thông báo
 * thân thiện thay vì màn hình trắng (rules: error handling rõ ràng ở mọi tầng).
 */
import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";

function describeError(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`;
  if (error instanceof Error) return error.message;
  return "Đã xảy ra lỗi không mong muốn.";
}

export function RouteError() {
  const error = useRouteError();
  return (
    <section className="gp-route-error" role="alert" aria-labelledby="route-error-heading">
      <h1 id="route-error-heading">Có lỗi xảy ra</h1>
      <p>{describeError(error)}</p>
      {/* Link (không reload) — giữ token in-memory + cache khi quay lại trong SPA. */}
      <Link to="/">Về trang tổng quan</Link>
    </section>
  );
}
